import { Client } from '@twilio/conversations';
import { ChatEngineHandle } from '../../interfaces/chat-model.interface';

export class TwilioChatEngineHandle implements ChatEngineHandle {
  protected maybeClient: Client | null;

  public constructor(client: Client | null) {
    this.maybeClient = client;
  }

  public get client(): Client {
    if (this.isValid()) {
      return this.maybeClient;
    } else {
      throw new Error('Twilio client is not initialized');
    }
  }

  public isValid(): boolean {
    return this.maybeClient !== null;
  }
}
